import {mainQuery} from '@github-ui/react-core/future/main-query'
import {pullRequestsAppBuilder} from '../config/app-builder'
import type {BaseComparisonInfoRoutePayload, OverviewRoutePayload} from './route-payload-types'
import type {ReviewRequestsData} from '../page-data/payloads/review-requests'
import type {AssigneesData} from '../page-data/payloads/assignees'
import {pageDataQuery} from './page-data-query'

export const pullRequestsOverviewRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsOverviewRoute', {
  path: '/:owner/:repo/pull/:pr_number/overview',
  queries: [
    mainQuery<OverviewRoutePayload>(),
    pageDataQuery<ReviewRequestsData, 'review_requests'>('review_requests', true),
    pageDataQuery<AssigneesData, 'assignees'>('assignees'),
    pageDataQuery<BaseComparisonInfoRoutePayload, 'base_comparison_info'>('base_comparison_info'),
  ],
})
